import React, {useState, memo} from "react";
import {useTranslation} from "react-i18next";
//local
import {ButtonTransparent} from "components/buttons/ButtonTransparent";
import {Input} from "components/Input";
import {Tag} from "components/Tag";
import {IconMailLetter} from "components/icons";
import {color} from "constants/color.consts";

export const SignContractMemberEmailInput = memo(
  ({defaultValue, edit, loading, onAdd, addClass}) => {
    const {t} = useTranslation();
    const [value, setValue] = useState(defaultValue);

    return (
      <div className={`df-row-center ${addClass ? addClass : ""}`}>
        <IconMailLetter height="30" width="30" color={color.purple} addClass="mr-2" />
        {edit ? (
          <Input
            name="email"
            small
            fontSize="14"
            fullWidth
            placeholder={t("TYPE_TO_ADD_EMAIL")}
            className="input"
            value={value}
            onChange={(e) => setValue(e.target.value)}
          />
        ) : (
          <Tag
            text={value}
            color={color.purple}
            noBackground
            medium
            normal
            round
            addClass="pl-2 pr-2 black"
          />
        )}
        {edit && (
          <ButtonTransparent
            disabled={!value}
            loading={loading}
            type="button"
            name="SIGN_CONTRACT_MEMBER_ADD_MODAL_ADD_BUTTON"
            small
            addClass="ml-2"
            onClick={() => onAdd(value)}
          />
        )}
      </div>
    );
  }
);
